export enum ColumnHeadersEnum {
    'ENTRY_NO' = 'ENTRY_NO',
    'DESIGNATION' = 'DESIGNATION',
    'CROSS' = 'CROSS',
    'ENTRY_CODE' = 'ENTRY_CODE',
    'GID' = 'GID',
    'GROUP_ID' = 'GROUP_ID',
    'FEMALE_CROSS' = 'FEMALE_CROSS',
    'MALE_CROSS' = 'MALE_CROSS',
    'GERMPLASM_ORIGIN' = 'GERMPLASM_ORIGIN',
    'INDEX' = 'INDEX',
}
